interface ClientInfoMapProps {
    clientAddress?: string;
    clientLocationUrl?: string;
}

const extractCoordsFromGoogleMapsUrl = (url: string): string | null => {
    let match = url.match(/\/(?:place|search)\/([\d.\-]+)[+, ]+([\d.\-]+)/);
    if (match) return `${match[1]},${match[2]}`;

    match = url.match(/!3d([\d.\-]+)!4d([\d.\-]+)/);
    if (match) return `${match[1]},${match[2]}`;

    match = url.match(/[?&]q=([\d.\-]+),([\d.\-]+)/);
    if (match) return `${match[1]},${match[2]}`;

    return null;
};

const ClientInfoMap = ({ clientAddress = '', clientLocationUrl = '' }: ClientInfoMapProps) => {
    const encodedAddress = encodeURIComponent(clientAddress);
    const coords = clientLocationUrl ? extractCoordsFromGoogleMapsUrl(clientLocationUrl) : null;

    const src = coords
        ? `https://www.google.com/maps?q=${coords}&output=embed&z=14`
        : `https://www.google.com/maps?q=${encodedAddress}&output=embed&z=12`;

    return (
        <iframe
            width="100%"
            height="400"
            frameBorder="0"
            style={{ border: 0, borderRadius: '8px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src={src}
        />
    );
};

export default ClientInfoMap;
